module.exports = "<div class=\"container container-single\">\r\n  \r\n  <h2>Credentials Confirmation</h2>\r\n  <div *ngIf=\"message\" class=\"message\">{{message}}</div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/lostCredentials/lostCredentials.confirmation.html
// module id = 156
// module chunks = 0